module.exports = __webpack_public_path__ + "static/media/play.9bfb2138.svg";